exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vc-conf-datetime .flatpickr-input{background:#fff!important;max-width:200px}", ""]);

// exports
